import {KalmanFilter} from "kalman-filter";

const ConstantPosition = function() {
    return new KalmanFilter({
        observation: {
            sensorDimension: 2,
            name: "sensor"
        },
        dynamic: {
            name: "constant-position",
            covariance: [0.1, 0.1]
        }
    });
};

export default ConstantPosition;
